"use client";

import React, { useRef, useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
const servicesData = [
  {
    title: "خدمات پس از فروش",
    icon: "/section5/After_Sales_Service.svg",
    image: "/section5/After_Sales_Service.webp",
    colorImage: "/section5/After-Sales_Service-color.webp",
    link: "/services",
  },
  {
    title: "پشتیبانی",
    icon: "/section5/Customer_Support.svg",
    image: "/section5/Customer_Support.webp",
    colorImage: "/section5/Customer_Support-color.webp",
    link: "/support",
  },
  {
    title: "نوبت دهی اینترنتی تعمیرگاه",
    icon: "/section5/Online_Appointment.svg",
    image: "/section5/Online_Appointment.webp",
    colorImage: "/section5/Online_Appointment-color.webp",
    link: "/repairshopReserve",
  },
  {
    title: "سرویس در محل",
    icon: "/section5/Online_Appointment.svg",
    image: "/section5/service2.webp",
    colorImage: "/section5/service2-color.webp",
    link: "/homeServices",
  },
  {
    title: "قطعات و آپشن",
    icon: "/section5/Parts_Accessories.svg",
    image: "/section5/Parts_Accessories.webp",
    colorImage: "/section5/Parts_Accessories_color.webp",
    link: "/options",
  },
];

export default function Services({ isDark }) {
  const sliderRef = useRef(null);
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const isDragged = useRef(false);
  const [snapClass, setSnapClass] = useState("snap-x snap-mandatory md:snap-none");

  // Center the slider on desktop to align slide 2 and 3 with the Slogan above it
  useEffect(() => {
    const handleScroll = () => {
      if (!sliderRef.current) return;
      const el = sliderRef.current;

      if (window.innerWidth >= 768) {
        // Desktop centering logic
        if (el.children.length >= 4) {
          const cardWidth = el.children[2].offsetWidth;
          const gap = 32; // md:gap-8 is 32px
          const rightPadding = 32; // md:px-8 is 32px

          // Distance from the absolute right edge of the scroll area to the right edge of child 2
          const rightEdgeOfChild2FromRight = rightPadding + 2 * cardWidth + 2 * gap;

          // The width of the two center cards plus the gap between them
          const sloganWidth = 2 * cardWidth + gap;

          // The padding on the side of the slogan in the viewport
          const sloganPadding = (el.clientWidth - sloganWidth) / 2;

          // Calculate exact scroll needed from right so child 2 aligns with the slogan padding
          const targetScrollFromRight = rightEdgeOfChild2FromRight - sloganPadding;

          el.scrollLeft = -targetScrollFromRight;
          if (el.scrollLeft === 0 && targetScrollFromRight > 1) {
            el.scrollLeft = targetScrollFromRight; // Fallback for some browsers
          }
        }
      } else {
        // Mobile logic: scroll exactly to the 2nd slide (index 1)
        const firstChild = el.children[0];
        if (firstChild) {
          // Calculate distance between centers (width + gap-4 which is 16px)
          const slideDistance = firstChild.offsetWidth + 16;
          // Apply scroll in RTL
          el.scrollLeft = -slideDistance;
          // Fallback if browser uses positive scroll for RTL
          if (el.scrollLeft === 0) {
            el.scrollLeft = slideDistance;
          }
        }
      }
    };

    handleScroll();

    // Ensure layout is settled (images loaded, fonts applied)
    const t1 = setTimeout(handleScroll, 100);
    const t2 = setTimeout(handleScroll, 500);

    window.addEventListener("resize", handleScroll);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const handleMouseDown = (e) => {
    isDown.current = true;
    isDragged.current = false;
    startX.current = e.pageX - sliderRef.current.offsetLeft;
    scrollLeft.current = sliderRef.current.scrollLeft;
    setSnapClass("md:snap-none"); // disable mobile snapping temporarily if dragging
  };

  const handleMouseLeave = () => {
    isDown.current = false;
    setSnapClass("snap-x snap-mandatory md:snap-none");
  };

  const handleMouseUp = () => {
    isDown.current = false;
    setSnapClass("snap-x snap-mandatory md:snap-none");
  };

  const handleMouseMove = (e) => {
    if (!isDown.current) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    if (Math.abs(walk) > 10) {
      isDragged.current = true;
    }
    sliderRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const handleClick = (e) => {
    if (isDragged.current) {
      e.preventDefault();
    }
  };

  return (
    <section className={`w-full py-12 md:py-24 transition-colors duration-[1200ms] ease-in-out ${isDark ? "bg-[#050505] text-white" : "bg-white text-gray-900"}`}>
      <style dangerouslySetInnerHTML={{
        __html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}} />

      <div dir="rtl" className="w-full  mx-auto overflow-hidden relative">
        <div
          ref={sliderRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          className={`w-full flex overflow-x-auto ${snapClass} gap-4 md:gap-8 px-4 md:px-8 pb-8 hide-scrollbar cursor-grab active:cursor-grabbing`}
        >
          {servicesData.map((service, idx) => (
            <Link
              key={idx}
              href={service.link}
              onClick={handleClick}
              draggable="false"
              className="shrink-0 snap-center relative overflow-hidden group 
                         w-[85vw] max-w-[400px] aspect-[810/1261] rounded-card-mob md:rounded-card-desk
                         md:w-[calc((100vw-128px)/2)] lg:w-[calc((min(100vw,1700px)-160px)/2)] md:max-w-none md:aspect-[76/32] md:h-auto "
            >
              <Image
                src={service.image}
                alt={service.title}
                fill
                draggable="false"
                className="object-cover transition-transform duration-700 group-hover:scale-105 pointer-events-none"
                sizes="(max-width: 768px) 85vw, 760px"
              />

              <div className="absolute inset-0 pointer-events-none z-0 transition-all duration-[2000ms] ease-in-out [clip-path:inset(0_0_0_100%)] group-hover:[clip-path:inset(0_0_0_0)]">
                <Image
                  src={service.colorImage}
                  alt={`${service.title} colored`}
                  fill
                  draggable="false"
                  className="object-cover transition-transform duration-700 group-hover:scale-105 pointer-events-none"
                  sizes="(max-width: 768px) 85vw, 760px"
                />
              </div>

              <div className="absolute inset-0 flex flex-col items-center justify-between p-8 md:hidden pointer-events-none">
                <div className="flex flex-col items-center gap-4 mt-6">
                  <img src={service.icon} alt={service.title} className="w-16 h-16 brightness-0 invert" />
                  <h3 className="text-white text-2xl font-light tracking-wide">{service.title}</h3>
                </div>
                <div className="w-full max-w-[280px] border border-white/80 rounded-[20px] py-4 text-center text-white backdrop-blur-sm bg-black/10 group-active:bg-white/20 transition-colors font-light text-lg">
                  مشاهده
                </div>
              </div>

              <div className="absolute inset-0 hidden md:block pointer-events-none">
                <div className="absolute top-10 right-10 flex flex-col items-start gap-3">
                  <div
                    className="w-11 h-11 bg-gray-600"
                    style={{
                      WebkitMaskImage: `url(${service.icon})`,
                      WebkitMaskSize: "contain",
                      WebkitMaskRepeat: "no-repeat",
                      WebkitMaskPosition: "center",
                      maskImage: `url(${service.icon})`,
                      maskSize: "contain",
                      maskRepeat: "no-repeat",
                      maskPosition: "center",
                    }}
                  />
                  <h3 className=" text-xl font-light tracking-wide text-gray-600">{service.title}</h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}